module.exports = __webpack_public_path__ + "media/images/writer/monitor/mv-imgline-1a70fb168daf3e439bac5d0e76e2574c.png";